import React from 'react'
import logo from './logo.svg'
import './App.css'
import AddEntryComponent from "./components/add_entry"
import Grid2 from '@mui/material/Unstable_Grid2'
import Container from '@mui/material/Container'
import { UsersTable } from './components/users_table'
import MainPage from './pages/main_page'
import { Route, Routes } from 'react-router-dom'
import { LoginPage } from './pages/login_page'
import { ProtectedRoute } from './providers/protected_routh'
import { AuthProvider } from './providers/auth_provider'
import AddDocumentPage from './pages/add_document_page'
import { Environment } from './services/envirmoent'

function App() {
  console.log(Environment.environment)

  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <MainPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/add"
          element={
            <ProtectedRoute>
              <AddDocumentPage />
            </ProtectedRoute>
          }
        />
      </Routes>
    </AuthProvider>
  )
}

export default App
